// extracted by mini-css-extract-plugin
module.exports = {"container":"OfficialHomeContent_container__GWsvh"};